import { Roarr as log } from "roarr";

import type { GridStackTile } from "../../../types/tile";
import { getRuntimeTrayLayout } from "../../trayLayout";
import type { TileArranger } from ".";

export const arrangeTilesWithoutGaps: TileArranger = (tiles) => {
    let outputTiles: GridStackTile[] = [];
    const { columns, rows } = getRuntimeTrayLayout();

    let x = 0;
    let y = 0;
    for (const sortedTiles of tiles) {
        for (const sortedTile of sortedTiles) {
            outputTiles = [
                ...outputTiles,
                {
                    colour: sortedTile.Colour,
                    tileType: sortedTile.TileType,
                    x,
                    y,
                    staging: false,
                },
            ];

            x++;
            if (x >= columns) {
                y++;
                x = 0;
            }

            if (y > rows - 1) {
                log.error("Too many tiles to arrange in the tray; aborting");
                return outputTiles;
            }
        }
    }

    return outputTiles;
};
